// Messages for operator/settings/NotificationPreferences (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.notification_preferences.head': 'Notification preferences — Operator',
  'operator.notification_preferences.title': 'Notification preferences',
  'operator.notification_preferences.desc': 'Choose which updates email you',
  'operator.notification_preferences.heading': 'Email me about',
  'operator.notification_preferences.list_desc':
    "Turn email on or off for each event. When it's on, we email you as it happens; the in-app inbox always keeps every event, on or off.",
}

export const zhTW = {
  'operator.notification_preferences.head': '通知偏好 — 操作員',
  'operator.notification_preferences.title': '通知偏好',
  'operator.notification_preferences.desc': '選擇哪些更新會以電子郵件通知您',
  'operator.notification_preferences.heading': '以電子郵件通知我',
  'operator.notification_preferences.list_desc':
    '為每個事件開啟或關閉電子郵件。開啟時，我們會即時以電子郵件通知您；無論開啟或關閉，站內收件匣都會保留每個事件。',
}
